import React from 'react'
import { Text, SelectField, CardContainer, Icon } from '@adc/ui-morpheus'
import { constants } from '@adc/ui-core'
import type { CognitionEvaluationRubric } from '@adc/sdk/types'
import classnames from 'classnames/bind'
import styles from './styles.scss'

const cx = classnames.bind(styles)

interface OthersEvaluationsSectionProps {
  filteredRubrics: CognitionEvaluationRubric[]
  selectedEvaluatorId: string
  onEvaluatorChange: (evaluatorId: string) => void
  evaluatorOptions: Array<{
    text: React.ReactNode
    value: string
    content?: React.ReactNode
  }>
  selectedRubric?: CognitionEvaluationRubric
}

const OthersEvaluationsSection: React.FC<OthersEvaluationsSectionProps> = ({
  filteredRubrics,
  selectedEvaluatorId,
  onEvaluatorChange,
  evaluatorOptions,
  selectedRubric,
}) => {
  // Get rating from the selected rubric
  // eslint-disable-next-line no-nested-ternary
  const rating = selectedRubric?.score
    ? 'thumbsUp'
    : selectedRubric?.score === false
    ? 'thumbsDown'
    : null

  return (
    <CardContainer
      backgroundColor={constants.ColorNames.White}
      borderRadius='medium'
      padding='small'
      borderStyle='line'
      borderColor={constants.ColorNames.GrayExtraLight}
    >
      <Text
        size='large'
        weight='heavy'
        className={cx('section-title')}
        style={{ marginBottom: filteredRubrics.length === 0 ? '0' : '16px' }}
      >
        Others' Evaluations{' '}
        {filteredRubrics.length === 0
          ? '(none)'
          : `(${filteredRubrics.length})`}
      </Text>

      {filteredRubrics.length > 0 && (
        <>
          <div className={cx('detail-row')}>
            <Text size='small' color='gray'>
              Evaluator:
            </Text>

            {filteredRubrics.length > 0 ? (
              <div style={{ flex: 1 }}>
                <SelectField
                  className={cx('select-field')}
                  hideWrapper
                  value={selectedEvaluatorId}
                  onChange={(_e: unknown, data: { value: string }) =>
                    onEvaluatorChange(data?.value)
                  }
                  options={evaluatorOptions}
                  compact
                  elmId='evaluator'
                />
              </div>
            ) : (
              <Text size='small'>Not evaluated</Text>
            )}
          </div>
          <div className={cx('detail-row')}>
            <Text size='small' color='gray'>
              Rating:
            </Text>
            <div>
              {rating ? (
                <>
                  <Icon
                    iconStyle='solid'
                    name={rating === 'thumbsUp' ? 'thumbs-up' : 'thumbs-down'}
                    color={rating === 'thumbsUp' ? 'success' : 'error'}
                    size='large'
                  />
                </>
              ) : (
                <Text size='small'>Not rated</Text>
              )}
            </div>
          </div>

          <div className={cx('comment-section')}>
            <Text
              size='small'
              color='gray'
              style={{ marginBottom: '8px', display: 'block' }}
            >
              Comment
            </Text>
            <CardContainer
              style={{ marginTop: '8px' }}
              backgroundColor={constants.ColorNames.OffWhite}
              padding='extra-small'
              borderRadius='medium'
            >
              {selectedRubric?.notes || 'No comment provided'}
            </CardContainer>
          </div>
        </>
      )}
    </CardContainer>
  )
}

export default OthersEvaluationsSection
